import { ReactNode } from "react"
import styled from "styled-components"
import { v4 as uuidv4 } from "uuid"

import { Spinner } from "components/common/Spinner"
import { Tooltip } from "components/common/Tooltip"

const StatCardWrapper = styled.div`
  flex: 1 1 0;
  min-width: 200px;
  background: var(--surface-1);
  border-radius: 24px;
  padding: 24px;
  border: 1px solid var(--border-default);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
`

const StatCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
`

const TooltipWrapper = styled.div`
  margin-left: auto;
`

const StatCardTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 24px;
  margin-right: 6px;
`

const StatCardValue = styled.div`
  font-size: 40px;
  font-weight: 500;
  color: var(--text-primary);
  display: flex;
  align-items: center;
`

const StyledTooltip = styled(Tooltip)<{ $tooltipMaxWidth?: number }>`
  span {
    &:after {
      transform: scale(1.4);
      display: inline-block;
      top: 1px;
    }
  }

  div {
    max-width: ${p => p.$tooltipMaxWidth ?? 140}px;
    text-align: center;
    z-index: 2100;
  }
`

interface StatCardProps {
  title: string
  value: number
  infoTooltip?: string
  tooltipMaxWidth?: number
  isLoading?: boolean
  content?: ReactNode
}

export const StatCard = ({ title, value, infoTooltip, tooltipMaxWidth, isLoading, content }: StatCardProps) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <StatCardValue>
          <Spinner justifyContent="flex-start" />
        </StatCardValue>
      )
    }

    if (content) {
      return content
    }

    return <StatCardValue>{value.toLocaleString()}</StatCardValue>
  }

  return (
    <StatCardWrapper>
      <StatCardHeader>
        <StatCardTitle>{title}</StatCardTitle>
        {infoTooltip && (
          <TooltipWrapper>
            <StyledTooltip id={uuidv4()} text={" "} orientation="top" $tooltipMaxWidth={tooltipMaxWidth}>
              {infoTooltip}
            </StyledTooltip>
          </TooltipWrapper>
        )}
      </StatCardHeader>
      {renderContent()}
    </StatCardWrapper>
  )
}
